import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-list-nested-object',
  templateUrl: './list-nested-object.component.html',
})
export class ListNestedObjectComponent implements OnInit {

  @Input('value') value: Object;
  @Input('parentKey') parentKey: string;

  formattedValue: {key: string, value: Object}[] = [];

  @Output() onClick: EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.formattedValue = this.getFormattedValue(this.value);
  }

  getFormattedValue(value: Object) {
    return Object.keys(value).map(key => {
      return {
        key,
        value: value[key],
        path: this.parentKey ? `${this.parentKey}__${key}` : this.isObject(value[key]) ? '' : key,
      };
    });
  }

  //noinspection JSMethodCanBeStatic
  isObject(value: any) {
    return _.isObject(value);
  }

  showDetails(path: string) {
    this.onClick.emit(path);
  }

  /**
   * Wrape partner onClick to its nested lists
   *
   * @param state
   */
  wrappedOnClick(state) {
    this.onClick.emit(state);
  }
}
